import './utils/appInsights';
import './index.css';
import '@ingka/status/dist/style.css';

import App from './App';
import React from 'react';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root') as HTMLElement;

// create a root
const root = createRoot(container);

//render app to root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

